import { JsonFetch } from "@roc-digital/mxm-base/logic";
import { Article, ArticleSchema } from "@roc-digital/mxm-base/src/data";

export interface ListSimpleParams {
  query?: string;
  scope?: string;
  page?: number;
  count?: number;
  status?: 'published' | 'drafted';
  scheduled?: boolean;
}

export async function listArticles(params: ListSimpleParams) {
  const query = Object.keys(params).filter(key => {
    return params[key] !== 'undefined' && params[key] !== 'null' && params[key] !== null && params[key] !== undefined && params[key] !== '';
  })
  .map(key => `${key}=${params[key]}`)
  .join('&');

  return await JsonFetch<{
    data: ArticleSchema[],
    paging: {count: number, limit: number, page: number}
  }>({
    url: `${process.env.REACT_APP_AUX_API_URL}/admin/articles?${query}`
  });
}